<template>
  <f7-actions :opened="opened">
    <f7-list
      form
      class="u-mb2 no-hairlines no_list_bootm_border margin_top_none"
    >
      <f7-list-item>
        <div class="fx align-items-center justify-content-between">
          <h2 class="title u-p0">Add referral info</h2>
          <button
            @click="$emit('close')"
            type="button"
            class="icon-button rounded"
          >
            <img src="/static/svg/iconoir_delete-circle.svg" alt="close icon" />
          </button>
        </div>
      </f7-list-item>
      <f7-list-item>
        <f7-label>First Name</f7-label>
        <f7-input
          type="text"
          name="firstName"
          v-model="referral.firstName"
          v-validate="'required|alpha'"
        />
        <span v-show="errors.has('firstName')" class="error-message">
          {{ errors.first("firstName") }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Last Name</f7-label>
        <f7-input
          type="text"
          name="lastName"
          v-model="referral.lastName"
          v-validate="'required|alpha'"
        />
        <span v-show="errors.has('lastName')" class="error-message">
          {{ errors.first("lastName") }}
        </span>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Mobile Phone</f7-label>
        <div
          class="item-input item-input-field not-empty-state"
          masked="true"
          data-vv-id="6"
          aria-invalid="false"
        >
          <vue-tel-input
            data-vv-name="Phone"
            v-model="referral.referralContactPhone"
            :phone="referral.referralContactPhone"
            v-validate.continues="{ required: true, phone: true }"
            :invalid="invalidPhone"
          ></vue-tel-input>
        </div>
        <span v-if="invalidPhone" class="error-message">
          {{errors.first('Phone')}}
        </span>
      </f7-list-item>
      <f7-list-item>
        <div class="fx align-items-center justify-content-between">
          <button
            :disabled="invalidForm"
            type="button"
            class="button"
            :style="buttonStyle"
            @click="onSave()"
          >
            Save
          </button>
          <button type="button" class="button u-danger" @click="onCancel()">
            Cancel
          </button>
        </div>
      </f7-list-item>
    </f7-list>
  </f7-actions>
</template>

<script>
export default {
  name: 'AddReferralModal',
  props: {
    opened: {
      type: Boolean,
      required: true,
      default: false
    },
    buttonStyle: {
      type: Object,
      default: {}
    }
  },
  watch: {
    opened (val) {
      if (!val) {
        this.referral.firstName = null
        this.referral.lastName = null
        this.referral.referralContactPhone = null
        this.$validator.reset()
        this.isPhoneValid = true
      }
    }
  },
  computed: {
    invalidForm () {
      return this.errors.any()
    },
    invalidPhone () {
      return this.errors.first('Phone')
    }
  },
  methods: {
    onSave () {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$emit('submit', {
            firstName: this.referral.firstName,
            lastName: this.referral.lastName,
            phone: this.referral.referralContactPhone
          })
        }
      })
    },
    onCancel () {
      this.$emit('cancel')
    }
  },
  data () {
    return {
      referral: {
        firstName: null,
        lastName: null,
        referralContactPhone: null
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// add-referral-modal.vue?3775e5f2